// extracted by mini-css-extract-plugin
export var root = "fc-content-block-module--root--d9c3b";